// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentsMobile_root__Pgdjy","item":"PaymentsMobile_item__1AYkN","label":"PaymentsMobile_label__9K-PJ","amount":"PaymentsMobile_amount__MRmVG"};